import { render, staticRenderFns } from "./userBar.vue?vue&type=template&id=1cf515fc&"
import script from "./userBar.vue?vue&type=script&lang=js&"
export * from "./userBar.vue?vue&type=script&lang=js&"
import style0 from "./userBar.vue?vue&type=style&index=0&id=1cf515fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports